import api from '@/api';
export default {
    getBoard(boardId: number): Promise<board.BoardItem>{
        return api.get<board.BoardItem>({
            url:`/Portal/Board/api/GetBoard?boardId=${boardId}`
        })
    },

    getWriteConfig(boardId: number): Promise<board.BoardItem>{
        return api.get<board.BoardItem>({
            url: `/Portal/Board/api/writeConfig?boardId=${boardId}`
        })
    },

    getReadConfig(boardId: number): Promise<board.BoardItem>{
        return api.get<board.BoardItem>({
            url: `/Portal/Board/api/writeConfig?boardId=${boardId}`
        })
    },

    getBoardManagers(boardId: number): Promise<board.BoardManager[]> {
        return api.get({
            url: `/Portal/BoardAdmin/api/getBoardManagers`,
            params: {
                boardId: boardId
            }
        })
    },

    getBoardPermission(boardId: number): Promise<board.BoardPermission> {
        return api.get({
            url: `/Portal/Board/api/boardPermission`,
            params: {
                boardId: boardId
            }
        })
    },

    // 24시간 이내 신규 게시글이 있는지 확인
    hasNewArticles(boardId: number): Promise<boolean> {
        return api.get<boolean>({
            url: `/Portal/Board/api/hasNewArticles`,
            params: {
                boardId: boardId
            }
        })
    }
}